import React from "react";
import GuestPage from "../components/layouts/GuestPage/GuestPage";
import NavBar from "../components/layouts/GuestLayout/NavBar/NavBar"

class GuestRoutes extends React.Component {
  render() {
    const { history } = this.props;

    return (
      <div>
        <NavBar history={history} />
        <GuestPage history={history} />
      </div>
    );
  }
}

export default GuestRoutes;
